import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'

export default function SelectField({ label, name, value, options, onChange, invalid, optional }) {
  return (
    <Form.Group as={Row} className="mb-3">
      <Form.Label column md={5} className="classification-step__label">
        {label}
        {!optional && <span className="classification-step__required"> *</span>}
      </Form.Label>
      <Col md={7}>
        <Form.Control
          as="select"
          name={name}
          value={value}
          onChange={onChange}
          className={invalid ? 'classification-step__select--invalid' : ''}
        >
          <option value=''>Select...</option>
          {options.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </Form.Control>
        {invalid && (
          <div className="classification-step__required-hint">Required</div>
        )}
      </Col>
    </Form.Group>
  )
}
